import SessionAccessStatus from './SessionAccessStatus';

export default SessionAccessStatus;
